import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Select extends Component {
  static propTypes = {
    accent: PropTypes.bool,
    center: PropTypes.bool,
    error: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
      }),
    ),
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    indie: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { indie } = this.props;

    if (!indie && this.state.value != nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  onChange = e => {
    const { onChange, name } = this.props;

    this.setState({
      value: e.target.value,
    });

    if (onChange) onChange(e.target.value, name);
  };

  render() {
    const { accent, center, error, label, name, indie, options } = this.props;
    const { value } = this.state;

    let classes = ['select'];

    if (accent) classes.push('select--accent');
    if (center) classes.push('select--center');
    if (error) classes.push('select--error');

    const optionList = options.map(opt => (
      <option key={opt.id} value={opt.id}>
        {opt.name}
      </option>
    ));

    return (
      <div className={classes.join(' ')}>
        <select
          name={name}
          className="select__field"
          value={value}
          onChange={this.onChange}
        >
          {optionList}
        </select>
        {label ? <div className="select__label">{label}</div> : null}
      </div>
    );
  }
}

export default Select;
